import { useController, type UseFormReturn } from 'react-hook-form';
import type { ExtractStringKeys } from '../../../types/extractKeysOfType';
import { Controlled_Markdown } from '../../inputs/controlled/Controlled_Markdown';

export const Form_Markdown = <T extends object>({
    name,
    form,
    readonly,
}: {
    name: ExtractStringKeys<T, false>;
    form: UseFormReturn<T>;
    readonly: boolean;
}) => {
    const {
        field: { value, onChange: valueOnChange },
    } = useController({
        control: form.control,
        name,
    });

    return (
        <Controlled_Markdown
            value={value}
            onChange={valueOnChange}
            readonly={readonly}
        />
    );
};
